import { ref, onBeforeMount } from 'vue'
import { getStudio } from '@/api/payManage/appManage'
export default function () {
  const studioList = ref([])
  const getStudioList = async () => {
    try {
      const { code, data } = await getStudio()
      if (code === '0') {
        studioList.value =
          data?.map((item: Record<string, any>) => ({
            ...item,
            label: item.name,
            value: item.name,
          })) ?? []
      }
    } catch (error) {
      console.error(error)
    }
  }
  onBeforeMount(() => {
    getStudioList()
  })

  return {
    studioList,
  }
}
